<template>
  <el-dialog
    v-model="visible"
    title="Управление ролями"
    width="800px"
    class="roles-manager-dialog"
    align-center
  >
    <el-button type="primary" class="roles-manager-toolbar-btn" @click="openRoleForm(null)">Добавить должность</el-button>

    <el-table :data="roles" border class="roles-manager-table" style="margin-top: 20px">
      <el-table-column prop="name" label="Название" />
      <el-table-column label="Права">
        <template #default="scope">
          <div v-if="scope.row.permissions.length === 1 && scope.row.permissions[0] === '*'">
            <el-tag type="success" size="small" style="margin: 2px">все</el-tag>
          </div>
          <div v-else>
            <div class="perm-tags-row">
              <el-tag
                v-for="perm in scope.row.permissions.slice(0, 4)"
                :key="perm"
                type="info"
                size="small"
                style="margin: 2px"
              >
                {{ permissionLabels[perm] || perm }}
              </el-tag>
              <el-popover
                v-if="scope.row.permissions.length > 4"
                placement="top"
                width="300"
                trigger="click"
              >
                <div style="max-height:200px;overflow-y:auto;">
                  <el-tag
                    v-for="perm in scope.row.permissions"
                    :key="perm"
                    type="info"
                    size="small"
                    style="margin: 2px"
                  >
                    {{ permissionLabels[perm] || perm }}
                  </el-tag>
                </div>
                <template #reference>
                  <el-tag
                    type="warning"
                    size="small"
                    style="margin: 2px; cursor: pointer"
                  >
                    + ещё {{ scope.row.permissions.length - 4 }}
                  </el-tag>
                </template>
              </el-popover>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Действия" width="150">
        <template #default="scope">
          <template v-if="isAdminRole(scope.row)">
            <span class="roles-manager-empty">—</span>
          </template>
          <template v-else>
            <div class="roles-manager-actions">
              <el-button size="small" @click="openRoleForm(scope.row)">Ред.</el-button>
              <el-button size="small" type="danger" @click="deleteRole(scope.row)">Удл.</el-button>
            </div>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <RoleFormDialog
      v-model="showForm"
      :role="currentRole"
      :permission-labels="permissionLabels"
      :permission-groups="permissionGroups"
      @submit="handleRoleSubmit"
    />
  </el-dialog>
</template>

<script>

import RoleFormDialog from '@/components/views/modal/RoleFormDialog.vue'
import { mapGetters } from 'vuex'
import { permissionGroups, permissionLabels } from '@/components/util/accessHelper'

export default {
  components: { RoleFormDialog },
  props: {
    modelValue: Boolean,
    employees: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      visible: this.modelValue,
      showForm: false,
      currentRole: null,
      permissionLabels,
      permissionGroups,
    }
  },
  computed: {
    ...mapGetters('roles', { rolesFromStore: 'roles' }),
    roles() {
      return this.rolesFromStore
    }
  },
  watch: {
    modelValue(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('update:modelValue', val)
    }
  },
  methods: {
    openRoleForm(role) {
      this.currentRole = role || {
        name: '',
        permissions: []
      }
      this.showForm = true
    },
    async deleteRole(node) {
      if (this.employees.some(emp => emp.role?.id === node.id || emp.role_id === node.id)) {
        this.$message.error('Невозможно удалить: должность используется сотрудником')
        return
      }
      const message = `Вы уверены, что хотите удалить должность "${node.name}"?`
      this.$confirm(message, 'Внимание', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning'
      }).then(async () => {
        await this.$store.dispatch('roles/deleteRole', node.id);
      }).catch(() => {
        this.$message({ type: 'info', message: 'Удаление отменено' })
      })
    },
    async handleRoleSubmit(roleData) {
      try {
        if (roleData.id) {
          await this.$store.dispatch('roles/updateRole', roleData)
        } else {
          await this.$store.dispatch('roles/createRole', roleData)
        }
        await this.$store.dispatch('roles/fetchRoles')
      } catch (error) {
        console.error('Ошибка сохранения роли:', error)
      }
      this.showForm = false
    },
    isAdminRole(role) {
      if (typeof role.permissions === 'string' && role.permissions === '*') return true
      if (Array.isArray(role.permissions) && role.permissions.length === 1 && role.permissions[0] === '*') return true
      return false
    }
  }
}
</script>
<style>
.perm-tags-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  min-height: 32px;
}

.roles-manager-dialog.el-dialog {
  width: min(800px, calc(100vw - 24px)) !important;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid rgba(110, 146, 214, 0.2);
  background: linear-gradient(180deg, rgba(12, 28, 55, 0.98), rgba(7, 18, 36, 0.98));
}

.roles-manager-dialog .el-dialog__header,
.roles-manager-dialog .el-dialog__body,
.roles-manager-dialog .el-dialog__footer {
  background: transparent;
}

.roles-manager-dialog .el-dialog__title {
  color: #eef5ff;
}

.roles-manager-toolbar-btn.el-button,
.roles-manager-dialog .el-button--primary {
  border: none;
  background: linear-gradient(135deg, #22c0ff, #2b7cff);
}

.roles-manager-table.el-table,
.roles-manager-dialog .el-table__expanded-cell,
.roles-manager-dialog .el-table tr,
.roles-manager-dialog .el-table th.el-table__cell,
.roles-manager-dialog .el-table td.el-table__cell {
  background: #08172f !important;
  color: #d7e7ff !important;
  border-bottom-color: rgba(174, 194, 230, 0.1) !important;
}

.roles-manager-table.el-table {
  --el-table-border-color: rgba(174, 194, 230, 0.1);
  --el-table-header-bg-color: #0e2447;
  --el-table-row-hover-bg-color: rgba(0, 195, 254, 0.08);
  border: 1px solid rgba(110, 146, 214, 0.12);
  border-radius: 16px;
  overflow: hidden;
}

.roles-manager-dialog .el-table th.el-table__cell {
  color: rgba(174, 194, 230, 0.72) !important;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.roles-manager-dialog .el-tag {
  border-color: rgba(110, 146, 214, 0.18);
}

.roles-manager-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.roles-manager-empty {
  color: rgba(174, 194, 230, 0.56);
}

.roles-manager-dialog .el-button:not(.el-button--primary) {
  background: rgba(12, 34, 75, 0.92);
  border-color: rgba(110, 146, 214, 0.18);
  color: #d7e7ff;
}

.roles-manager-dialog .el-button--danger {
  color: #ffb4bc;
}

@media (max-width: 640px) {
  .roles-manager-dialog.el-dialog {
    width: calc(100vw - 16px) !important;
  }
}
</style>
